module.exports = __webpack_public_path__ + "img/val3icon1.5eeba119.png";